import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function CardListIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="4" y="4" width="5.83333" height="5.83333" rx="2" fill={props.fill} />
			<rect x="14.1671" y="4" width="5.83333" height="5.83333" rx="2" fill={props.fill} />
			<rect x="4" y="14.1667" width="5.83333" height="5.83333" rx="2" fill={props.fill} />
			<rect x="14.1671" y="14.1667" width="5.83333" height="5.83333" rx="2" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CardListIcon fill={props.fill} />
		</div>
	);
}